import { Stack } from 'expo-router';

import { FruitSlicePageBackground } from '../../../fruit-slices/components/FruitSlicePageBackground';
import { FruitSlicesListPage } from '../../../fruit-slices/components/FruitSlicesListPage';

export default function FruitSlicesIndexPage() {
    return (
        <>
            <Stack.Screen options={{ title: 'Fruit Slices' }} />
            <FruitSlicePageBackground>
                <FruitSlicesListPage />
            </FruitSlicePageBackground>
        </>
    );
}
